import { useContext } from 'react';

import AppContext from './private/AppContext';

export default function useMarkAllAsNotDone() {
  return useContext(AppContext).markAllAsNotDone;
}
